// Copyright (c) 2023-present VexFlow contributors: https://github.com/vexflow/vexflow/graphs/contributors
// @author: Taehoon Moon 2014
// MIT License
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ClefNote_glyphCategory;
import { Clef } from './clef';
import { Glyph } from './glyph';
import { Note } from './note';
import { Category } from './typeguard';
import { upperFirst } from './util';
/** ClefNote implements clef annotations in measures. */
export class ClefNote extends Note {
    static get CATEGORY() {
        return Category.ClefNote;
    }
    constructor(type, size = 'default', annotation) {
        super({ duration: 'b' });
        _ClefNote_glyphCategory.set(this, void 0);
        this.setType(type, size, annotation);
        this.ignoreTicks = true;
    }
    /** Set clef type, size and annotation. */
    setType(type, size = 'default', annotation) {
        this.type = type;
        this.size = size;
        const clef = new Clef(type, size, annotation);
        this.clef = clef.clef;
        this.annotation = clef.annotation;
        const category = 'clefNote' + upperFirst(this.size);
        __classPrivateFieldSet(this, _ClefNote_glyphCategory, category, "f");
        this.setWidth(Glyph.getWidth(this.clef.code, Clef.getPoint(this.size), category));
        return this;
    }
    /** Get associated clef. */
    getClef() {
        return this.clef;
    }
    preFormat() {
        this.preFormatted = true;
        return this;
    }
    /** Render clef note. */
    draw() {
        const stave = this.checkStave();
        const ctx = this.checkContext();
        this.setRendered();
        const absoluteX = this.getAbsoluteX();
        const x = absoluteX;
        const y = stave.getYForLine(this.clef.line);
        Glyph.renderGlyph(ctx, x, y, Clef.getPoint(this.size), this.clef.code, { category: __classPrivateFieldGet(this, _ClefNote_glyphCategory, "f") });
        // If the Vex.Flow.Clef has an annotation, such as 8va, draw it.
        if (this.annotation !== undefined) {
            const attachment = new Glyph(this.annotation.code, this.annotation.point);
            attachment.setContext(ctx);
            attachment.setStave(stave);
            attachment.setYShift(stave.getYForLine(this.annotation.line) - stave.getYForGlyphs());
            attachment.setXShift(this.annotation.xShift);
            attachment.renderToStave(absoluteX);
        }
    }
}
_ClefNote_glyphCategory = new WeakMap();
